import React from "react";

export const PlaceholderText = props => {
  const text = props.text ? props.text : "Non renseigné";
  return <span style={{ fontStyle: "italic" }}>{text}</span>;
};
export const HighlightedText = ({ request, children, field }) => {
  const isHightlighted = request && request.data && request.data[field];
  return (
    <span
      style={{
        backgroundColor: isHightlighted ? "#F7ED98" : null,
        border: isHightlighted ? "#E46901 1px solid" : null,
        borderRadius: 4
      }}
    >
      {children}
    </span>
  );
};



// WEBPACK FOOTER //
// src/pages/basepdc/Components/CustomSpan.component.js